var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  viewBox: "0 0 25 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M22.759 0H2.24C1.478 0 0 1.478 0 2.241V22.76C0 23.52 1.478 25 2.24 25h10.685v-9.493H9.48v-3.43h3.446v-2.64c0-3.23 2.444-5.146 5.325-5.146 1.38 0 2.106.148 2.452.193v3.27l-2.444-.001c-1.567 0-1.859.776-1.859 1.87v2.454h4.35l-.568 3.43H16.4V25h6.359C23.52 25 25 23.52 25 22.759V2.24C25 1.478 23.52 0 22.759 0Z"
})));
export default SvgIconFacebook;